import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const postLogoFileData = (file, state, setState) => {
  if (file) {
    const formData = new FormData();
    formData.append("name", file?.name || '');
    formData.append("file", file);

    const api = initApi(API_NAMES.TIMES, state, setState);
    const url = `/TimeFiles/logo`;
    return api?.executeObject ? api.executeObject(url, 'POST', formData, true) : null;
  }
};

const getLogoFileData = (fileUrl, state, setState) => {
  if (fileUrl) {
    const api = initApi(API_NAMES.TIMES, state, setState);
    const url = `/TimeFiles/logo?fileUrl=${fileUrl}`;

    return api?.executeObject ? api.executeObject(url, 'GET', null, false, true) : null;
  }
};

const BASE_UPLOAD_URL = import.meta.env.VITE_TIMES_DOCS_LOGOS_BASE_UPLOAD_URL;

const INITIAL_LOGO_FILE_UPLOAD_STATE = {
  ...BASIC_INITIAL_STATE
};

const INITIAL_LOGO_FILE_DOWNLOAD_STATE = {
  ...BASIC_INITIAL_STATE
};

const LogoFileData = {
  BASE_UPLOAD_URL,
  INITIAL_LOGO_FILE_UPLOAD_STATE,
  INITIAL_LOGO_FILE_DOWNLOAD_STATE,
  postLogoFileData,
  getLogoFileData
};

export default LogoFileData;